import { __awaiter } from "tslib";
import { getConfig, isConfigSet, getOauthClientId } from '@local/app-config';
import { trackError } from '@local/metrics';
import { v4 as uuid } from 'uuid';
import { LOGIN_SUCCESS_ROUTE, LOGIN_SILENT } from '../constants';
import { setCSRFState } from '../store/sessionStorageHelpers/authStateHelpers';
import { setPkceVerifier } from '../store/sessionStorageHelpers/pkceFlowHelpers';
import { getPkceChallenge } from './getPkceChallenge';
export function getAuthUrl(forceOauthPrefix, additionalScopes) {
    return __awaiter(this, void 0, void 0, function* () {
        let baseUrl = '';
        if (isConfigSet()) {
            const config = getConfig();
            baseUrl = config.identity_url;
        }
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.length) > 0) {
            const clientId = getOauthClientId(forceOauthPrefix);
            const redirectUrl = `${window.location.origin}${LOGIN_SUCCESS_ROUTE}` || '';
            const authUrl = new URL(`${baseUrl}/oauth2/authz`);
            const query = authUrl.searchParams || new URLSearchParams();
            const defaultScopes = ['openid', 'profile', 'email'];
            const state = uuid();
            setCSRFState(state);
            query.append('response_type', 'code');
            query.append('client_id', clientId);
            query.append('redirect_uri', redirectUrl);
            query.append('state', state);
            query.append('scope', [...defaultScopes, ...additionalScopes].join(' '));
            const { codeChallenge, codeVerifier } = yield getPkceChallenge();
            query.append('code_challenge', codeChallenge);
            query.append('code_challenge_method', 'S256');
            setPkceVerifier(codeVerifier);
            authUrl.search = query.toString();
            return authUrl;
        }
        trackError('Error getting config for getAuthUrl');
        window.location.reload();
        return undefined;
    });
}
export function getBentleyAuthUrl(_a) {
    return __awaiter(this, arguments, void 0, function* ({ forceOauthPrefix, additionalScopes, tabId, silent, extendSession, }) {
        let baseUrl = '';
        if (isConfigSet()) {
            const config = getConfig();
            baseUrl = config.bentleyBaseUrl;
        }
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.length) > 0) {
            const clientId = getOauthClientId(forceOauthPrefix);
            const redirectUrl = extendSession
                ? `${window.location.origin}${LOGIN_SILENT}`
                : `${window.location.origin}${LOGIN_SUCCESS_ROUTE}`;
            const url = `${baseUrl}/connect/authorize`;
            const authUrl = new URL(url);
            const query = authUrl.searchParams || new URLSearchParams();
            const defaultScopes = ['openid', 'profile', 'email'];
            const state = uuid();
            setCSRFState(state, tabId);
            query.append('response_type', 'code');
            query.append('client_id', clientId);
            query.append('redirect_uri', redirectUrl);
            query.append('state', state);
            query.append('scope', [...defaultScopes, ...additionalScopes].join(' '));
            if (silent) {
                query.append('prompt', 'none');
            }
            const { codeChallenge, codeVerifier } = yield getPkceChallenge();
            query.append('code_challenge', codeChallenge);
            query.append('code_challenge_method', 'S256');
            setPkceVerifier(codeVerifier, tabId);
            authUrl.search = query.toString();
            return authUrl;
        }
        trackError('Error getting config for getBentleyAuthUrl');
        window.location.reload();
        return undefined;
    });
}
//# sourceMappingURL=getAuthUrl.js.map